import { GET_MANAGEMENT_REVIEWS_DATA_API } from "../../constants/api";
import axios from "../fetch/fetch";

export const getManagementReviewsDataAPI = async (): Promise<any[]> => {
    const response = await axios.get(GET_MANAGEMENT_REVIEWS_DATA_API);
    return response.data;
};
